<mat-form-field appearance="outline">
  <mat-label>Id рекламы</mat-label>
  <mat-select
    [value]="recordCalendarId.toString()"
    (selectionChange)="handleChange($event.value)"
  >
    <mat-option></mat-option>
    @for (option of recordCalenderIdSelectData; track option.id) {
      <mat-option [value]="option.id">
        {{ option.id }}: {{ option.value }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
